var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.brand.url}},[_c('img',{attrs:{"src":("" + (_vm.publicPath + _vm.brand.logo)),"alt":_vm.brand.title,"width":_vm.brand.width,"height":_vm.brand.height}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }